import { Component, EventEmitter, Output, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgxDropzoneChangeEvent, NgxDropzoneModule } from 'ngx-dropzone';

@Component({
    selector: 'r1-compass-app-file-dropzone',
    imports: [MatButtonModule, NgxDropzoneModule],
    templateUrl: './file-dropzone.component.html',
    styleUrl: './file-dropzone.component.scss',
})
export class FileDropzoneComponent {
    public readonly file = input.required<File | undefined>();

    @Output()
    download: EventEmitter<void> = new EventEmitter();

    @Output()
    fileAdded: EventEmitter<NgxDropzoneChangeEvent> = new EventEmitter();

    @Output()
    fileRemoved: EventEmitter<void> = new EventEmitter();

    onDownload() {
        this.download.emit();
    }

    onFileAdded(event: NgxDropzoneChangeEvent) {
        this.fileAdded.emit(event);
    }

    onFileRemoved() {
        this.fileRemoved.emit();
    }
}
